export class DroppPriceResponse {

  status: number;
  message: string;

  /**
   * Price for a dropp location within the capital based
   * on weight
   */
  droppcapital: DroppPriceModel[] = [];

  /**
   * Price for a dropp location outside of the capital based
   * on weight
   */
  droppoutside: DroppPriceModel[] = [];

  /**
   * Price for packages being sent home in the capital outside
   * of business hours
   */
  homecapital: DroppPriceModel[] = [];

  /**
   * Price for packages being sent home during regular
   * business hours
   */
  dayhomecapital: DroppPriceModel[] = [];

  /**
   * For the locations which support it we can send packages home
   * outside of the capital
   */
  homeoutside: DroppPriceModel[] = [];

  /**
   * Other locations refers to the pricine for package which are sent
   * to the nerest available Samskip locations
   */
  otherlocations: DroppPriceModel[] = [];

  static generate(json: any): DroppPriceResponse {

    const price = new DroppPriceResponse();
    price.status = json.status;
    price.message = json.message;

    price.droppcapital = DroppPriceModel.generateList(json['droppcapital']);
    price.droppoutside = DroppPriceModel.generateList(json['droppoutside']);

    price.homecapital = DroppPriceModel.generateList(json['homecapital']);
    price.dayhomecapital = DroppPriceModel.generateList(json['dayhomecapital']);
    price.homeoutside = DroppPriceModel.generateList(json['homeoutside']);

    price.otherlocations = DroppPriceModel.generateList(json['otherlocations']);

    return price;

  }

}

export class DroppPriceModel {

  price: number;
  maxweight: number;

  static generate(json: any): DroppPriceModel {

    const price = new DroppPriceModel();
    price.price = json['price'];
    price.maxweight = json['weight'];

    return price;

  }

  static generateList(jsonList: any[]): DroppPriceModel[]{

    const list = [];
    for (const json of jsonList) {
      list.push(DroppPriceModel.generate(json));
    }

    return list;

  }

}
